import PropTypes from 'prop-types';
import { useContext } from 'react';
import { DraftContext } from '../../../context/DraftContext';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { CircularProgress } from '@mui/material';

export const SubmissionProgressForm = ({formSubmissionStatus}) => {
  const { draftState: { draft: { signers } } } = useContext(DraftContext);
  const { streamProgress, response } = formSubmissionStatus;

  return (
    <div className="form-request-progress">
      <div>
        {
          streamProgress.map(({message, status, hasError}, index) => {
            return (
              <>
                <div key={index} className='form-request-progress__progress--item'>
                  { <IconStatus status={status} hasError={hasError}/> }
                  <p className='md-text grey-text' style={{marginLeft: '12px'}}>{message}</p>
                </div>
                { 
                  index === 2 && 
                  <ul style={{marginLeft: '24px'}}>
                    { 
                      Object.keys(signers).map((signerId, index) => {
                        return (
                          <li key={index} className='form-request-progress__progress--signers-item'>
                            { <IconStatus status={status} hasError={hasError}/> }
                            <p className='md-text grey-text'>{signers[signerId].email}</p>
                          </li>
                        )
                      })
                    }
                  </ul>
                }
              </>
            )
          })
        }
      </div>
      <br />
      <p className={`${response.hasError ? 'error-text' : 'success-text'}`}>{response.message}</p>

    </div>
  )
}

export const IconStatus = ({status = 'pending', hasError}) => {
  switch (status) {
    case 'pending':
      return <CircularProgress color='secondary' size={20} sx={{fontSize: '1.4rem'}}/>
    case 'completed':
      if (hasError) return <CancelRoundedIcon color='error' sx={{fontSize: '1.4rem'}}/>
      return <CheckCircleRoundedIcon color='success' sx={{fontSize: '1.4rem'}}/>
  }
}


SubmissionProgressForm.propTypes = {
  formSubmissionStatus: PropTypes.object.isRequired
}

IconStatus.propTypes = {
  status: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired
}
